/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-05-27 16:18:59
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-05-27 16:50:45
 */

export default {
    path: 'mix_recharge',
    component: () => import( /* webpackChunkName: "common-list" */ '@/pages/mix/RechargeList'),
    meta: {
        title: '账户充值记录'
    }
}